import PropTypes from 'prop-types'

import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

export const CardModelContent = ({make, model}) => (
  <div className={`mt-ListCarouselCardContent`}>
    <TitleBasic as={titleBasicTags.h3} color={titleBasicColors.currentColor} size={titleBasicSizes.xs} title={make} />
    <span className={`mt-ListCarouselCardContent-description`}>{model}</span>
  </div>
)

CardModelContent.displayName = 'CardModelContent'
CardModelContent.propTypes = {
  make: PropTypes.string,
  model: PropTypes.string
}
